"use client";

import Link from "next/link";
import React from "react";
import { twMerge } from "tailwind-merge";

import { useHash } from "@/hooks/use-hash.hook";
import { BUTTON_STYLES } from "@/styles/buttons";

export type PriceCardTabProps = {
    anchor: string;
    initialAnchor?: string;
    tabLabel: string;
};

export const PriceCardTabView = ({ anchor, initialAnchor, tabLabel }: PriceCardTabProps) => {
    const hash = useHash();

    return (
        <Link
            href={"#" + anchor}
            prefetch={false}
            className={twMerge(
                BUTTON_STYLES.tab(hash === undefined ? false : (hash || initialAnchor) === anchor),
                "whitespace-nowrap",
            )}
        >
            {tabLabel}
        </Link>
    );
};
